import { AvailableLockSystem } from "@/api/lockSystems/lockSystems";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from "@heroui/react";

export function PromptLockSystemModal({
  disclosure,
  lockSystems,
  selectLockSystem,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  lockSystems: AvailableLockSystem[];
  selectLockSystem: (lockSystem: AvailableLockSystem) => void;
}) {
  return (
    <>
      <Modal
        isOpen={disclosure.isOpen}
        onOpenChange={disclosure.onOpenChange}
        portalContainer={document.getElementById("main")!}
        backdrop="blur"
        scrollBehavior="outside"
        size="4xl"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>
                <div className="w-full items-center flex flex-row justify-between gap-2">
                  <span>Выберите систему для создания</span>
                </div>
              </ModalHeader>
              <ModalBody>
                <div className="grid grid-cols-2 gap-2">
                  {lockSystems && (
                    <>
                      {lockSystems.map((lockSystem, index) => (
                        <div
                          className="flex flex-col bg-background border-2 border-default-200 rounded-xl cursor-pointer select-none p-4"
                          key={index}
                          onClick={() => selectLockSystem(lockSystem)}
                        >
                          <span>{lockSystem.label}</span>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button variant="flat" color="default" onClick={onClose}>
                  Закрыть
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
